var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"back-button",attrs:{"to":"/ferramentas"}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(_vm._s(_vm.$t("tools.goBackToTools"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }